const animateImages = () => {
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach((item) => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
				function handleIntersect(entries, observer) {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							let css_classlist = entry.target.classList;
							css_classlist.add("is-inview");

							observer.unobserve(entry.target);

							setTimeout(() => {
								css_classlist.remove("is-inview");
								css_classlist.remove("observe-me");
							}, 1000); // Duration matches the animation duration in SCSS
						}
					});
				}

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0.0,
				};

				let observer = new IntersectionObserver(handleIntersect, options);
				let targets = item.querySelectorAll(".observe-me");
				targets.forEach((target, index) => {
					observer.observe(target);
				});
			}

			createObserver();
		}
	});
};

const loadItems = (button) => {
	const totalEl = document.querySelector("[data-total-pages]");
	const currentEl = document.querySelector("[data-current-page]");
	const nextEl = document.querySelector("[data-next-url]");
	if (!totalEl || !currentEl || !nextEl) return;

	const totalPages = parseInt(totalEl.value);
	let currentPage = parseInt(currentEl.value);
	let currentPageScroll = currentPage + 1;

	currentPage = currentPage + 1;
	const nextUrl = nextEl.value.replace(/page=[0-9]+/, "page=" + currentPage);
	const nextUrlScroll = nextEl.value.replace(/page=[0-9]+/, "page=" + currentPageScroll);
	currentEl.value = currentPage;

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	const onComplete = () => {
		if (currentPage <= totalPages) {
			const scollData = document.querySelector(".infinite-scroll__data");
			if (scollData && currentPage != totalPages) {
				scollData.querySelector("input[data-next-url]").dataset.nextUrl = nextUrlScroll;
				scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
				scollData.querySelector("input[data-current-page]").dataset.currentPage = currentPage;
				scollData.querySelector("input[data-current-page]").value = currentPage;
				checkVisibility();
			}
			button.removeAttribute("disabled");
			button.classList.remove("loading");
			if (currentPage == totalPages) {
				button.remove();
			}

			animateImages();
			if (typeof loadeMoreSlider_G === "function" && loadeMoreSlider_G != null) {
				loadeMoreSlider_G();
			}
		}
	};

	fetch(nextUrl, { headers: { Accept: "text/html" } })
		.then((r) => r.text())
		.then((responseHTML) => {
			const doc = new DOMParser().parseFromString(responseHTML, "text/html");
			const newGrid = doc.querySelector(".load-more-grid");
			const grid = document.querySelector(".load-more-grid");
			if (newGrid && grid) {
				grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
			}
			if (typeof colorSwatches === "function") colorSwatches();
		})
		.catch((e) => console.error("load more", e))
		.finally(onComplete);
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
					sectionObserver.unobserve(entry.target);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
	animateImages();
}

(function () {
	loadMore();
})();
